import React from "react";
import { Button, Container } from "@mui/material";
import { Logo } from "asset";
import { NavLink } from "react-router-dom";
import {
  Email,
  Facebook,
  Instagram,
  LinkedIn,
  LocalDrink,
  LocationOn,
  PhoneAndroid,
  Twitter,
} from "@mui/icons-material";

const Footer = () => {
  const informationSection = [
    { name: "Contact Us", path: "/contact" },
    { name: "About Us", path: "/about" },
    { name: "Privacy Policy", path: "/privacypolicy" },
    { name: "Terms & Conditions", path: "/terms" },
  ];

  const serviceSection = [
    { name: "My Account", path: "/profile" },
    { name: "Order History", path: "/profile/myorder" },
    { name: "Wish List", path: "/profile/wishlist" },
  ];

  return (
    <>
      <main className="footer-main">
        <Container>
          <div className="footer-main-container flex-row justify-content-between flex-wrap gap-1">
            <div className="footer-logo-desc flex-column gap-2 ">
              <div className="footer-logo-left">
                <img src={Logo} alt="Logo" />
              </div>
              <div className="footer-dsc-left">
                Our Drinking water gives five steps of water purification.
                Promising quality and ensuring the latest technology and serving
                the water with labelled bottles with trust and honesty.
              </div>
            </div>
            <div className="footer-information-section flex-column gap-2">
              <h3 className="footer-information-section-title">Information</h3>
              <ul className="footer-information-section-ul flex-column gap-1">
                {informationSection.map((item, index) => {
                  return (
                    <li className="footer-information-section-li" key={index}>
                      <NavLink to={item.path}>{item.name}</NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="footer-service-section flex-column gap-2">
              <h3 className="footer-service-section-title">Service</h3>

              <ul className="footer-service-section-ul flex-column gap-1">
                {serviceSection.map((item, index) => {
                  return (
                    <li className="footer-service-section-li" key={index}>
                      <NavLink to={item.path}>{item.name}</NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="footer-contactus-section flex-column gap-2">
              <h3 className="footer-contactus-section-title">Contact Us</h3>
              <div className="footer-contactus-section-container  flex-column gap-1">
                <span className="flex-row align-items-center gap-1 social-location ">
                  <LocationOn /> Khandagiri,Bhubaneswar,Odisha,India
                </span>
                <span className="flex-row align-items-center gap-1 social-phone">
                  <PhoneAndroid /> +91 8114957912
                </span>
                <span className="flex-row align-items-center gap-1 social-email">
                  <Email /> info@searchingyard.com
                </span>
              </div>
              <div className="footer-contactus-social flex-row gap-1">
                <a
                  href="/"
                  target="_blank"
                  className="social-twitter"
                  rel="noopener noreferrer"
                >
                  <Twitter />
                </a>
                <a
                  href="/"
                  target="_blank"
                  className="social-facebook"
                  rel="noopener noreferrer"
                >
                  <Facebook />
                </a>
                <a
                  href="/"
                  target="_blank"
                  className="social-instagram"
                  rel="noopener noreferrer"
                >
                  <Instagram />
                </a>
                <a
                  href="/"
                  target="_blank"
                  className="social-linkedin"
                  rel="noopener noreferrer"
                >
                  <LinkedIn />
                </a>
              </div>
            </div>
          </div>
        </Container>
        <div className="back-to-top">
          <Button
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
          >
            <LocalDrink />
          </Button>
        </div>
      </main>
      <div className="footer-copyright flex-row  ">
        <Container>
          <div className="flex-row justify-content-between">
            <span>
              &copy; {new Date().getFullYear()} Searching Yard. All rights
              reserved.{" "}
            </span>
            <span>
              Designed and Developed by{" "}
              <a href="https://searchingyard.com/">
                SearchingYard Software Pvt. Ltd.
              </a>
            </span>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Footer;
